require('./helpers/bundle-manifest').register(JSON.parse("{\"ioUUD\":\"index.2dedeed4.js\",\"l1paE\":\"sun.bd7540df.svg\",\"6q0tN\":\"moon.c747b72c.svg\"}"));